import useSWR from 'swr';
import { axiosInstance } from './api';

/** Настройки анализа речи точки (Алексей 22.10 #1799 AI373, 27.10 #2985) — BE speech_to_text/api/settings_views.py. */
export type SpeechCustomBar =
  | { kind: 'flag'; title: string; field: string }
  | { kind: 'upsell_item'; title: string; match: string };

export interface SpeechSettingsDto {
  /** Пункт чек-листа: true — оцениваем на точке, false — не показываем; нет ключа — по умолчанию. */
  items: Record<string, boolean>;
  bars: { hidden?: string[]; custom?: SpeechCustomBar[] };
  standard_bars?: { id: string; title: string }[];
}

export const speechSettingsKey = (zoneId: string | number) => ['speech-settings', String(zoneId)] as const;

export const getSpeechSettings = (zoneId: string | number) =>
  axiosInstance.get<SpeechSettingsDto>(`/speech_to_text/zones/${zoneId}/settings/`);

export const putSpeechSettings = (zoneId: string | number, body: Pick<SpeechSettingsDto, 'items' | 'bars'>) =>
  axiosInstance.put<SpeechSettingsDto>(`/speech_to_text/zones/${zoneId}/settings/`, body);

export function useSpeechSettings(zoneId: string | number | null | undefined) {
  return useSWR(zoneId != null && zoneId !== '' ? speechSettingsKey(zoneId) : null,
    () => getSpeechSettings(zoneId!).then((r) => r.data), { revalidateOnFocus: false, dedupingInterval: 60_000 });
}
